export default (context, inject) => {
  const emailValidator = {
    /**
     * Проверяет адрес электронной почты. Возвращает значение true, если адрес электронной почты действителен, и значение false в противном случае.
     * Регулярное выражение, используемое для проверки адреса электронной почты, является:
     * /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
     * @param {string} email Электронное письмо для подтверждения
     * @returns {boolean}
     */
    validate(email) {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return emailRegex.test(email)
    },

    /**
     * Возвращает сообщение об ошибке, если адрес электронной почты неверен, в противном случае - пустую строку.
     * @param {string} email Адрес электронной почты для проверки
     * @returns {string}
     */
    formatError(email) {
      if (!email) {
        return ''
      }
      if (!this.validate(email)) {
        return context.i18n.t('plugins.email_validator.invalid_email')
      }
      return ''
    },
  }

  inject('emailValidator', emailValidator)
}
